import React, { useEffect, useState } from "react";
import Switch from '@mui/material/Switch';
import { handleAutoAsing } from "../../../helpers/fetch";
import Tooltip from '@mui/material/Tooltip';

const AutoAsingSwitch = () => {

    const [checked, setChecked] = useState(true); //Estado para actualizar el check del switch.
    let userData = JSON.parse(localStorage.getItem("userData")); //Extraer los datos del usuario.

    //Funcion para manejar el estado en el switch.
    const handleChangeSwitch = async (event, switchStatus) => {
        setChecked(switchStatus);
        try {
            if (userData.IdUsuario) userData.AutoAsignar = switchStatus;
            console.log("userdata", userData)
            localStorage.setItem("userData", JSON.stringify(userData)); //Actualizar el valor del estado de asignación.

            let autoAsingData = await handleAutoAsing(switchStatus);
            console.log("esta es la respuesta de autoasignarse", autoAsingData);
        } catch (error) {
            console.log("falló autoasingarse *******", error)
        }
    };
    useEffect(() => {
        if (userData.IdUsuario) setChecked(userData.AutoAsignar);
    }, []);

    return (
        <div className="container-assingment">
            {/* <span className="container-assingment__text">Asignación {checked ? "Disponible" : "No disponible"}</span> */}
            <Tooltip title={`Autoasignar ${checked ? "Disponible" : "No disponible"}`} >
                <Switch onChange={handleChangeSwitch} checked={checked} className="switch-assignment" />
            </Tooltip>
        </div>
    )
};

export default AutoAsingSwitch;